import * as React from "react";
import { useSelector } from "react-redux";
import MuiAppBar from "../components/UtilityComponents/appBar_component";
import { NavigationConfig, } from "../utils/navigation_config";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import PageNotFound from "../pages/dashboard/pageNotFound/PageNotFound";
import Chatbot from "../components/chatbot";
import ChunkErrorBoundary from "../components/ChunkErrorBoundary";
import RouteLoadingSkeleton from "../components/RouteLoadingSkeleton";
const getUser = (state) => state.User;
const navConfig = NavigationConfig;
const ALLOWED_ROUTES = [
    navConfig.Dashboard,
    navConfig.CreateApplication,
    navConfig.UpdateApplication,
    navConfig.QuoteTool,
    navConfig.LineOfCredit,
    navConfig.UpdateLineOfCredit,
    navConfig.LocDetailsByTaxId,
    navConfig.ScheduleTakedownApplication,
    navConfig.DealerOperatedRentalFleet,
    navConfig.UpdateDealerOperatedRentalFleet,
    navConfig.DeepLinkMail,
    navConfig.SendApplicationLink,
    navConfig.AnalyticsDashboard,
    navConfig.QuoteHistory,
    navConfig.Applications,
    navConfig.RateCard,
    navConfig.QuotePreview,
];
const AuthenticatedLayout = () => {
    var _a;
    const navigate = useNavigate();
    const location = useLocation();
    const isLoggedIn = useSelector((state) => getUser(state).isLoggedIn);
    const userBasicInfo = useSelector((store) => store.User.userData);
    const roles = {
        HQMANAGER: ALLOWED_ROUTES,
        MANUFACTURER: ALLOWED_ROUTES,
        BRMANAGER: ALLOWED_ROUTES,
        VENDSREP: ALLOWED_ROUTES,
        CUSTOMER: ALLOWED_ROUTES,
        CUSTOMER_HQMANAGER: ALLOWED_ROUTES,
    };
    React.useEffect(() => {
        checkAuthentication();
    }, [isLoggedIn]);
    function checkAuthentication() {
        if (!isLoggedIn) {
            navigate(navConfig.Account.Login);
        }
        else {
            checkAuthorization();
        }
    }
    function checkAuthorization() {
        return true;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiAppBar, null),
        React.createElement("div", { className: "app-content-shell" }, !isLoggedIn ? null : ((_a = roles[userBasicInfo.RoleType]) === null || _a === void 0 ? void 0 : _a.includes(`/${location.pathname.split("/")[1]}`)) ? (React.createElement(ChunkErrorBoundary, null,
            React.createElement(React.Suspense, { fallback: React.createElement(RouteLoadingSkeleton, null) },
                React.createElement(Outlet, null)))) : (React.createElement(PageNotFound, null))),
        React.createElement(Chatbot, null)));
};
export default AuthenticatedLayout;
